module.exports = __webpack_public_path__ + "static/media/mars-stroke-v.0b6eca14.svg";